import React from 'react';
import { isMac } from '../../../utils/device';
import { Box, Text, useTheme } from '@ublend-npm/aulaui-core';

export const OmniSearchTip = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Text kind="p3" sx={{ color: theme.palette.text.secondary }}>
        Quick tip: You can press
      </Text>
      <Text
        kind="p3"
        sx={{
          paddingX: 1,
          borderRadius: 1,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        {isMac() ? '⇧ + ⌘ + F' : 'Ctrl+Shift+F'}
      </Text>
      <Text kind="p3" sx={{ color: theme.palette.text.secondary }}>
        to open search.
      </Text>
    </Box>
  );
};

OmniSearchTip.displayName = 'OmniSearchTip';
